import { useState, useEffect, useCallback, useRef } from "react";
import DynamicTable from "../../ui/DynamicTable";
import config from "../../../config/config";
import { BsThreeDotsVertical } from "react-icons/bs";
import Pagination from "../../ui/Pagination";
import { refreshRegulatoryBodiesTableData } from "../../../observers/dataObserver";
import { userSession } from "../../../observers/userObserver";
const RegulatoryBodyTable = () => {
    const [rows, setRows] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState({});
    const [pagination, setPagination] = useState({
        current_page: 1,
        total_items: 0,
        total_pages: 0,
        limit: 10
    });
    const dropdownRef = useRef(null);

    const token  = userSession.getToken()
    
    const getAuthHeaders = () => ({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    });

    const handlePageChange = (pageNumber) => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            current_page: pageNumber
        }));
    };

    const toggleDropdown = useCallback((id) => {
        setDropdownOpen((prev) => {
            const isOpen = prev[id];
            return isOpen
            ? {} // Close all if current is open
            : { [id]: true }; // Open only the current one
        });
    },[]);

    const fetchRecognizedExchanges = useCallback(async () => {
        try {
            const response = await fetch(`${config["backend-url"]}/regulatory_bodies_without_country?page=${pagination.current_page}&limit=${pagination.limit}`, {
                method: "GET",
                headers: getAuthHeaders()
            });

            let data = await response.json();
            if (response.ok) {
                const companyTypes = data.data.map((value) => ({
                    id: value.RegulatoryBodyID,
                    regulatoryBody: value.RegulatoryAuthority,
                    country: value.Location,
                    status: value.is_active
                }));
                setRows(companyTypes);
                setPagination(data.pagination);
            }
        } catch (error) {
            console.error(error);
        }
    }, [pagination.current_page, pagination.limit]);

    const toggleRowStatus = useCallback(async (row, status) => {
        try {
            const response = await fetch(`${config["backend-url"]}/Change_Required_Table`, {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify({
                    tableName: "RegulatoryBodies",
                    row: { id: row.id, is_active: status === "Activate", regulatoryBody: row.regulatoryBody, Country: row.country },
                    status, // "Activate" or "Deactivate"
                }),
            });
        
            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to update status");
            fetchRecognizedExchanges();
            // alert(`✅ ${status}d row successfully`);
        } catch (err) {
            console.error("❌ Failed to update status:", err);
            // alert("Failed to update row status.");
        }
    }, [fetchRecognizedExchanges]);

    const renderActionDropdown = useCallback((_, row) => {
        return (
            <div className="dropdown-container" key={row.id} ref={dropdownOpen[row.id] ? dropdownRef : null}>
            <button
                onClick={() => toggleDropdown(row.id)}
                className="dropdown-btn"
            >
                <BsThreeDotsVertical size={20} />
            </button>
            {dropdownOpen[row.id] && (
                <div className="custom-dropdown">
                    {!row.status ? <div
                        className="dropdownItem"
                        onClick={() => {toggleRowStatus(row, "Activate"); toggleDropdown(row.id)}}
                    >
                        Activate
                    </div> : <div
                        className="dropdownItem"
                        onClick={() => {toggleRowStatus(row, "Deactivate"); toggleDropdown(row.id)}}
                    >
                        Deactivate
                    </div>}
                </div>
            )}
            </div>
        );
    },[dropdownOpen, toggleDropdown, toggleRowStatus, dropdownRef]);

    const renderStatus = useCallback((value) => (
        <span className={`status-tile status-${value ? "active" : "inactive"}`}>
          {value ? "Active" : "Inactive"}
        </span>
    ),[]);

    useEffect(() => {
        fetchRecognizedExchanges();
        refreshRegulatoryBodiesTableData.subscribe(fetchRecognizedExchanges);
    }, [fetchRecognizedExchanges]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen({});
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const columns = [
                    { key: "regulatoryBody", label: "Regulatory Body" },
                    { key: "country", label: "Country" },
                    { key: "status", label: "Status", render: renderStatus },
                    { key: "action", label: "Actions", render: renderActionDropdown },
                ]

    return (
        <>
            <DynamicTable columns={columns} data={rows} />
            <Pagination totalPages={pagination.total_pages} page={pagination.current_page} handlePageChange={handlePageChange} />
        </>
    )

}

export default RegulatoryBodyTable;